import React from 'react';

const AvatarIcon = () =>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2232:2596)">
      <path
        d="M9.99957 0C7.22547 0 4.96875 2.25672 4.96875 5.03082C4.96875 7.80492 7.22547 10.0616 9.99957 10.0616C12.7737 10.0616 15.0304 7.80492 15.0304 5.03082C15.0304 2.25672 12.7737 0 9.99957 0ZM9.99957 8.58199C8.04148 8.58199 6.4484 6.98891 6.4484 5.03082C6.4484 3.07273 8.04148 1.47965 9.99957 1.47965C11.9577 1.47965 13.5507 3.07273 13.5507 5.03082C13.5507 6.98891 11.9577 8.58199 9.99957 8.58199Z"
        fill="#808080"
      />
      <path
        d="M9.99988 11.8398C5.57473 11.8398 2.1084 15.4253 2.1084 20.0026H3.58805C3.58805 16.1925 6.34465 13.3195 9.99988 13.3195C13.6551 13.3195 16.4117 16.1927 16.4117 20.0026H17.8914C17.8914 15.4253 14.425 11.8398 9.99988 11.8398Z"
        fill="#808080"
      />
    </g>
    <defs>
      <clipPath id="clip0_2232:2596">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>;

export default AvatarIcon;



// WEBPACK FOOTER //
// ./src/shared/components/Icons/AvatarIcon.js